import React from 'react';
import { useTranslation } from 'react-i18next';
import './building-create-next-step.component.scoped.sass';
import { NextStepProps } from 'src/types/next-step';
import Button from '@material-ui/core/Button/Button';
import { history } from 'react-router-guard';

export default function BuildingCreateNextStep(props: NextStepProps) {
  const { message, back, type } = props;
  const [t] = useTranslation();
  const backBuildings = () => {
    history.push('/buildings');
  }
  // const navigateToPayment = () => {
  //   history.push('/payment');
  // }

  return (
    <div className="next-step">
      {t(message)}
      <div className="buttons">
      {type === 'error' && <Button
        variant="contained"
        className="btn-tool btn-warning"
        onClick={back}
      >
        {t("back")}
      </Button>}
      <Button
        variant="contained"
        className="btn-tool btn-warning"
        onClick={backBuildings}
      >
        {t("back_buildings")}
      </Button>
      {/* {type === 'success' && <Button
        variant="contained"
        className="btn-tool btn-warning"
        onClick={navigateToPayment}
      >
        {t("proceed to payment")}
      </Button>} */}
      </div>
    </div>
  );
}
